import {extendTheme} from '@chakra-ui/react'
import retailReactAppTheme from '@salesforce/retail-react-app/app/theme'

// Foundational style overrides
import breakpoints from '../theme/foundations/breakpoints'
import colors from '../theme/foundations/colors'
import styles from '../theme/foundations/styles'
import {fontSizes, fontWeights, lineHeights} from '../theme/foundations/typography'
import fonts from '../theme/foundations/fonts'
import space from '../theme/foundations/space'
import shadows from '../theme/foundations/shadows'
import sizes from '../theme/foundations/sizes'
import textStyles from '../theme/foundations/textStyles'

// Base component style overrides
import Button from './components/base/button'
import Input from './components/base/input'
import Link from './components/base/link'
import Form from './components/base/form'
import Select from './components/base/select'
import Skeleton from './components/base/skeleton'
import Checkbox from './components/base/checkbox'
import Radio from './components/base/radio'
import FormError from './components/base/formError'
import FormLabel from './components/base/formLabel'
import Accordion from './components/base/accordion'
import Tooltip from './components/base/tooltip'
import Heading from './components/base/heading'
import Text from './components/base/text'
import Alert from './components/base/alert'
import Menu from './components/base/menu'
import Modal from './components/base/modal'
import Popover from './components/base/popover'
import Drawer from './components/base/drawer'
import Progress from './components/base/progress'
import Textarea from './components/base/textarea'
import Badge from './components/base/badge'

// Project Component style overrides
import App from './components/project/_app'
import Breadcrumb from './components/project/breadcrumb'
import PhoneField from './components/project/phone-field'
import ProductTile from './components/project/product-tile'
import DateField from './components/project/date-field'
import RadioButton from './components/project/radio-button'
import RadioButtonGroup from './components/project/radio-button-group'
import SwatchGroup from './components/project/swatch-group'
import Footer from './components/project/footer'
import LoadingSpinner from './components/project/loading-spinner'
import CartEditModal from './components/project/cart-edit-modal'
import Giftcard from './components/project/giftcard'
import Cart from './components/project/cart'
import PerfectYourLook from './components/project/perfect-your-look'

// Project Pages style overrides
import ProductViewContainer from './pages/productDetail'
import PageNotFound from './pages/pageNotFound'

// Please refer to the Chakra-Ui theme customization docs found
// here https://chakra-ui.com/docs/theming/customize-theme to learn
// more about extending and overriding themes for your project.
export const overrides = {
    ...retailReactAppTheme,

    // foundation styles
    breakpoints,
    colors,
    space,
    styles,
    fonts,
    fontSizes,
    fontWeights,
    lineHeights,
    shadows,
    sizes,
    textStyles,
    components: {
        ...retailReactAppTheme.components,

        // base components
        Button,
        Input,
        Link,
        Form,
        Select,
        Skeleton,
        Checkbox,
        Radio,
        FormError,
        FormLabel,
        Accordion,
        Tooltip,
        Heading,
        Text,
        Alert,
        Menu,
        Modal,
        Popover,
        Drawer,
        Progress,
        Textarea,
        Badge,

        // project components
        App,
        Breadcrumb,
        PhoneField,
        ProductTile,
        DateField,
        RadioButton,
        RadioButtonGroup,
        SwatchGroup,
        LoadingSpinner,
        ProductViewContainer,
        Footer,
        CartEditModal,
        Giftcard,
        Cart,
        PerfectYourLook,
        PageNotFound
    }
}

export default extendTheme(overrides)
